import { Controller } from 'stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
    static values = {
      journeyId: String,
      journeyTagId: Number,
      selectedTagId: Number
    }

    static targets = [
      'wasDrivingButton',
      'wasNotDrivingButton',
      'confirmButton'
    ]

    connect () {
      this.selectedTagIdValue = this.journeyTagIdValue
      this.journeyElement = $(`.trip-${this.journeyIdValue}`)

      if (this.journeyTagIdValue === 0) {
        this.wasDrivingButtonTarget.classList.add('button--option-active')
      } else {
        this.wasNotDrivingButtonTarget.classList.add('button--option-active')
      }
    }

    driving (e) {
      e.preventDefault()
      this.selectedTagIdValue = 0
      this.toggleButtons()
    }

    notDriving (e) {
      e.preventDefault()
      // If the current journey tag is not 'car' we want to keep it in db
      // Otherwise we want to tag it as 'passenger' (value: 2)
      this.selectedTagIdValue = this.journeyTagIdValue > 0 ? this.journeyTagIdValue : 2
      this.toggleButtons()
    }

    toggleButtons () {
      this.wasDrivingButtonTarget.classList.toggle('button--option-active')
      this.wasNotDrivingButtonTarget.classList.toggle('button--option-active')
    }

    confirm (e) {
      e.preventDefault()

      this.confirmButtonTarget.disabled = true
      this.confirmButtonTarget.innerHTML = I18n.t('components.journey_confirm_component.confirming')

      const data = {
        tag_id: this.selectedTagIdValue
      }

      Rails.ajax({
        type: 'patch',
        url: `/journeys/${this.journeyIdValue}/`,
        data: new URLSearchParams(data).toString(),
        success: (data) => this.handleResponse(data),
        error: () => {
          alert(I18n.t('components.journey_confirm_component.error'))
          this.confirmButtonTarget.disabled = false
          this.confirmButtonTarget.innerHTML = I18n.t('components.journey_confirm_component.confirm')
        }
      })
    }

    handleResponse (response) {
      if (response.success) {
        this.element.remove()

        this.updateUnsavedJourneysCount()
        this.journeyElement.find('.icon--not-locked').remove()
        this.journeyElement.find('.journey-confirmation').remove()
        this.journeyElement.find('.trip-footer').removeClass('hide')

        if (window.location.href.indexOf('/unconfirmed') > 0) {
          this.journeyElement.remove()
          return
        }

        if (this.selectedTagIdValue === 0) {
          this.handleDrivingStatus()
        } else {
          this.handleNotDrivingStatus()
        }

        updateIframe()
      }
    }

    handleDrivingStatus () {
      this.journeyElement.find('.score-dial').removeClass('hide')
      this.journeyElement.find('.trip-header__left')
        .append(`<p class="trip-header__driving_not_driving">${I18n.t('components.journey_confirm_component.was_driving')}</p>`)
      $('.journey_tabs, #journey-details-score').removeClass('hide')
      this.journeyElement.find('.trip-footer span').html(I18n.t('shared.journeys.footer.included'))

      // We only want to display events on the journey details page
      if (location.href.match(/\/journeys\/./)) {
        dispatchEvent(new Event('addEvents'))
      }
    }

    handleNotDrivingStatus () {
      this.journeyElement.find('.trip-header__date>span').addClass('dark-grey').removeClass('blue')
      this.journeyElement.find('.trip__inner').removeClass('trip__inner_driven').addClass('trip__inner_not_driven')
      this.journeyElement
        .find('.trip-header__left')
        .append(`<p class="trip-header__driving_not_driving">${I18n.t('components.journey_confirm_component.was_not_driving')}</p>`)
      this.journeyElement.find('.icon--not-driving').removeClass('hide')
      this.journeyElement
        .find('.trip-times__item__marker').removeClass('trip-times__item__marker')
        .addClass('trip-times__item__marker__not__driving')
      this.journeyElement.find('.trip-times').addClass('trip-times--not-driving')
      this.journeyElement.find('.trip-map').addClass('trip-map--greyscale')
      this.journeyElement.find('.trip-footer span').html(I18n.t('shared.journeys.footer.not_included'))

      if (window.location.href.indexOf(`/journeys/${this.journeyIdValue}`) > 0) {
        $('#journey-details').addClass('content')
      }
    }

    updateUnsavedJourneysCount () {
      const el = $('#unsaved-journeys-count-alert .alert--content .alert--content-title')
      const unsavedJourneysCount = Number($('#unsaved_journeys_count').html()) - 1
      const pluralizeSuffix = unsavedJourneysCount > 1 ? 's' : ''
      el.html(`You have <span id='unsaved_journeys_count'>${unsavedJourneysCount}</span> unconfirmed journey${pluralizeSuffix}`)

      if (unsavedJourneysCount === 0) {
        $('#unsaved-journeys-count-alert').hide()
        $('#up-to-date-journeys-alert').removeClass('hidden')
        $('.ball').remove()
      }
    }
}
